export default from './BidForm';



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOptions/components/BidPage/components/BidForm/index.js